import BarclaysLogo from './BarclaysLogo';
import FallbackLogo from './FallbackLogo';
import HSBCLogo from './HSBCLogo';
import LloydsLogo from './LloydsLogo';
import NatwestLogo from './NatwestLogo';

// eslint-disable-next-line import/no-default-export
export default {
    Barclays: BarclaysLogo,
    fallback: FallbackLogo,
    HSBC: HSBCLogo,
    'Lloyds Bank': LloydsLogo,
    'Natwest Bank': NatwestLogo
};
